import { ImageDimension, ImagePath } from '../../types';

export const getOriginalDimension = (
  imagePath: ImagePath
): Promise<ImageDimension> =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.addEventListener('error', reject);

    image.addEventListener('load', () => {
      resolve({
        width: image.width,
        height: image.height,
      });
    });

    image.src = imagePath;
  });
